/* La Pénombre · v2 : apparitions douces au défilement. Sans ce script, tout reste visible. */
(function () {
  var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduit || !('IntersectionObserver' in window)) return;
  var blocs = document.querySelectorAll('.lp .revele');
  if (!blocs.length) return;
  document.documentElement.classList.add('lp-anim');
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('vu'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -6% 0px' });
  blocs.forEach(function (b) { io.observe(b); });
  /* filet de sécurité : si un bloc n'a pas été vu (impression, capture), il s'affiche quand même */
  window.addEventListener('beforeprint', function () { blocs.forEach(function (b) { b.classList.add('vu'); }); });
})();